export interface Education {
  id: number;
  degree: string;
  school: string;
  period: string;
  location: string;
  description: string;
  specializations?: string[];
  achievements?: string[];
  type: "formation" | "diplome" | "certification" | "projet-academique";
  gpa?: string;
  status: "en-cours" | "obtenu" | "en-preparation";
}

export const education: Education[] = [
  {
    id: 1,
    degree: "Mastère Ingénierie du web",
    school: "ESGI",
    period: "2023 - 2025",
    location: "Paris, France",
    description:
      "Mastère axé sur le développement web moderne, les bonnes pratiques de code, le DevOps et la sécurité. L’alternance permet d’appliquer ces compétences directement en entreprise.",
    specializations: [
      "React, VueJS, Symfony",
      "NodeJS, NestJS",
      "MongoDB, PostgreSQL",
      "CI/CD, Docker",
      "Clean Code, SaaS",
      "Web Security",
    ],
    type: "formation",
    status: "en-cours",
    achievements: [
      "Formation en alternance chez Splash360",
      "Développement d'applications web modernes",
      "Maîtrise des frameworks frontend et backend",
      "Pratiques DevOps et sécurité web",
    ],
  },
  {
    id: 2,
    degree: "Licence projet web et mobile",
    school: "Sorbonne Université/CFA des Sciences",
    period: "2022 - 2023",
    location: "Paris, France",
    description:
      "Formation en développement web et mobile avec approche projet. Acquisition des compétences nécessaires pour créer des applications web et mobiles modernes.",
    specializations: [
      "Développement Web",
      "Développement Mobile",
      "Gestion de Projets",
      "Architecture Web",
    ],
    type: "diplome",
    status: "obtenu",
    achievements: [
      "Formation en alternance",
      "Projets web et mobile",
      "Maîtrise des technologies modernes",
      "Approche projet et travail en équipe",
    ],
  },
  {
    id: 3,
    degree: "DUT en informatique année spéciale",
    school: "IUT de Paris",
    period: "2021 - 2022",
    location: "Paris, France",
    description:
      "Année intensive en informatique orientée développement, base de données et gestion de projet. Ce parcours m’a permis d’acquérir de solides bases techniques.",
    specializations: [
      "Développement d'Applications",
      "Bases de Données",
      "Réseaux et Systèmes",
      "Gestion de Projets",
    ],
    type: "diplome",
    status: "obtenu",
    achievements: [
      "Projet : Site web pour atelier de réparation de vélos",
      "GitHub : https://jpbeguerisse.github.io/BeBiker/",
      "Technologies : HTML/CSS",
      "Approche projet et développement web",
    ],
  },
];

// Fonction pour obtenir les couleurs par type de formation
export const getTypeColor = (type: string) => {
  switch (type) {
    case "formation":
      return "from-blue-500 to-blue-600 dark:from-blue-400 dark:to-blue-500";
    case "diplome":
      return "from-green-500 to-green-600 dark:from-green-400 dark:to-green-500";
    case "certification":
      return "from-purple-500 to-purple-600 dark:from-purple-400 dark:to-purple-500";
    case "projet-academique":
      return "from-orange-500 to-orange-600 dark:from-orange-400 dark:to-orange-500";
    default:
      return "from-gray-500 to-gray-600 dark:from-gray-400 dark:to-gray-500";
  }
};

// Fonction pour obtenir les labels par type de formation
export const getTypeLabel = (type: string) => {
  switch (type) {
    case "formation":
      return "Formation";
    case "diplome":
      return "Diplôme";
    case "certification":
      return "Certification";
    case "projet-academique":
      return "Projet Académique";
    default:
      return type;
  }
};

// Fonction pour obtenir les couleurs par statut
export const getStatusColor = (status: string) => {
  switch (status) {
    case "en-cours":
      return "bg-yellow-100 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-200 border-yellow-200 dark:border-yellow-700/30";
    case "obtenu":
      return "bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-200 border-green-200 dark:border-green-700/30";
    case "en-preparation":
      return "bg-blue-100 dark:bg-blue-900/20 text-blue-800 dark:text-blue-200 border-blue-200 dark:border-blue-700/30";
    default:
      return "bg-gray-100 dark:bg-gray-900/20 text-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700/30";
  }
};

// Fonction pour obtenir les labels par statut
export const getStatusLabel = (status: string) => {
  switch (status) {
    case "en-cours":
      return "En cours";
    case "obtenu":
      return "Obtenu";
    case "en-preparation":
      return "En préparation";
    default:
      return status;
  }
};
